export function formatName(name: string): string {
  return name
    .trim()
    .replace(/[-_]/g, " ")
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
